/* Header: mega menus, mobile drawer tabs.

   Both are progressive enhancement. Without JavaScript every top-level item
   that opens a mega menu is still reachable — its children are links in the
   drawer markup, which is plain HTML — and no navigation is lost.
*/

(function () {
  'use strict';

  function setupMega(header) {
    const openers = header.querySelectorAll('[data-dopa-mega-open]');
    const panels = header.querySelectorAll('[data-dopa-mega]');
    if (!openers.length) return;

    let openId = null;

    function close() {
      panels.forEach(function (p) { p.hidden = true; });
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      openId = null;
    }

    function open(id) {
      panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-dopa-mega') !== id;
      });
      openers.forEach(function (o) {
        o.setAttribute('aria-expanded', String(o.getAttribute('data-dopa-mega-open') === id));
      });
      openId = id;
    }

    openers.forEach(function (opener) {
      const id = opener.getAttribute('data-dopa-mega-open');
      opener.addEventListener('click', function () {
        if (openId === id) close();
        else open(id);
      });
    });

    header.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && openId) {
        close();
        const active = header.querySelector('[data-dopa-mega-open][aria-expanded="false"]');
        if (active) active.focus();
      }
    });

    // Close when focus or pointer leaves the header entirely.
    document.addEventListener('click', function (event) {
      if (openId && !header.contains(event.target)) close();
    });
    header.addEventListener('focusout', function (event) {
      if (openId && !header.contains(event.relatedTarget)) close();
    });
  }

  function setupDrawer() {
    const drawer = document.querySelector('[data-dopa-drawer]');
    const opener = document.querySelector('[data-dopa-drawer-open]');
    if (!drawer || !opener) return;

    let lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      const first = drawer.querySelector('button, a');
      if (first) first.focus();
      document.addEventListener('keydown', onKey);
    }

    function close() {
      drawer.hidden = true;
      opener.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function onKey(event) {
      if (event.key === 'Escape') close();
    }

    opener.addEventListener('click', open);
    drawer.querySelectorAll('[data-dopa-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    // Three tabs, one panel at a time.
    const tabs = drawer.querySelectorAll('[data-dopa-tab]');
    const panels = drawer.querySelectorAll('[data-dopa-tab-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const id = tab.getAttribute('data-dopa-tab');
        tabs.forEach(function (t) {
          const on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', String(on));
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-dopa-tab-panel') === id);
        });
      });
    });
  }

  function boot() {
    const header = document.querySelector('[data-dopa-header]');
    if (header) setupMega(header);
    setupDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
